import { useQuery } from '@tanstack/react-query';

// common
import { KEYS_QUERY } from 'common/constants';
import { RAD_CODE } from 'common/hook/useUserRoles';
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceCommonRole, ReplaceRoles } from 'modules/account/types';

/**
 *  lấy mặc định 1 role cụ thể làm type chung cho các role khác
 */
export type CommonRole = ReplaceCommonRole;
export type Roles = ReplaceRoles;

/**
 * format lại dữ liệu để đúng với cấu trúc,
 * để map và hiển thị dữ liệu ở màn Gán vai trò
 */
export const formatRolesData = (isCCQL: boolean, r?: Roles): Partial<Roles> => {
  return !r
    ? ({} as Roles)
    : {
        businessRoles: isCCQL ? r.govAgencyRoles : r.clientRoles,
        adminRoles: r.adminRoles,
        systemRoles: r.systemRoles,
      };
};

/**
 * Lấy ra các vai trò + danh sách khách hàng theo vai trò  mà người dùng đang đăng nhập có thể tiếp cận
 */
const useGetAvailableRoles = () => {
  const service = useService();

  return useQuery({
    queryKey: [KEYS_QUERY.roleAssignmentConfig],
    queryFn: async () => {
      try {
        if (!service) return null;
        const res: Roles = await service.UserManagementController_getRoleAssignmentConfig();
        const noRADRole = {
          ...res,
          systemRoles: res.systemRoles.filter(({ code }) => code !== RAD_CODE), // không hiển thị thông tin của RAD
        };
        return noRADRole;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useGetAvailableRoles;
